import ProcessActionRoutes from '../../process/constants/process_action_routes';
import RestClient from '../../rest_client/rest_client.js';
import ResponseHandler from '../../rest_client/response_handler';
import { ProcessAPI, FlashMessageAPI } from 'lecom-api';

export const JavascriptActions = Reflux.createActions([
	'loadJavascripts'
]);

export const JavascriptStore = Reflux.createStore({
	listenables: JavascriptActions,
	store: {
		javascripts: []
	},

	onLoadJavascripts(options) {
		const { processInstanceData } = ProcessAPI.currentProcess();
		this.javascripts = processInstanceData().javascripts;

		if(this.javascripts) {
			this.sortJavascripts();
			this.injectJavascripts();
		}
		if (options && options.customScript && options.customScript.length) {
			options.customScript.forEach(this.buildScriptElement);
		}
	},

	injectJavascripts(index = 0) {
		let javascript = this.javascripts.find(js => js.order === index);
		// var javascript = this.javascripts[index];

		var flash = FlashMessageAPI.flash('flash-form');
		this.fetchJavascriptContent(javascript)
			.then(response => this.buildScriptElement(response.entity))
			.catch(reason => { flash.addMessage({ type: "error", message: Realize.i18n.t("javascript.errors.noLoad") }); })
			.then(() => { if (this.javascripts[index + 1]) this.injectJavascripts(index + 1); });
	},

	buildScriptElement(javascriptContent) {
		const script = document.createElement('script');

		script.textContent = javascriptContent;
		script.async = false;
		document.body.appendChild(script);
	},

	fetchJavascriptContent(javascript) {
		const javascriptUrl = this.buildUrl(javascript);
		return RestClient.load(javascriptUrl, {}, "GET", "application/javascript;charset=UTF-8");
	},

	buildUrl(javascript) {
		const { contextPath } = window;
		const { origin } = window.location;
		const route = ProcessActionRoutes.DOWNLOAD_JAVASCRIPT;
		const path = (!!contextPath.match(/^https?:\/\//)) ? `${contextPath}` : `${origin}${contextPath}`		

		return `${path}${route}?javascriptId=${javascript.id}`;
	},

	sortJavascripts() {
		this.javascripts.sort((j1, j2) => j1.order > j2.order);
	}
});

export default JavascriptStore;
